import React from 'react';
import Icon from '@sparebankenvest/ikoner/dist/icons/icon-check.svg';

export default (props) => <Icon {...props} />;
